import React, { useState, useRef, useEffect } from 'react';

const AudioQuestion = ({ id, question, playCount, numPlay, onPlay, onEndPlay }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (playCount < numPlay) {
      audioRef.current.play();
      setIsPlaying(true);

      if (typeof onPlay === 'function') {
        onPlay(id); // Inform parent bahwa audio mulai diputar
      }
    } else {
      alert('Audio hanya bisa diputar '+numPlay+' kali.');
    }
  };

  const handlePause = () => {
    audioRef.current.pause();
    setIsPlaying(false);
  };

  useEffect(() => {
    setCurrentTime(0);
    setIsPlaying(false);
  }, [id]);

  useEffect(() => {
    const audio = audioRef.current;

    const updateTime = () => {
      setCurrentTime(audio.currentTime);
    };

    const setAudioDuration = () => {
      setDuration(audio.duration);
    };

    const handleEnded = () => {
      setIsPlaying(false);
      setCurrentTime(0);

      // Beri tahu parent untuk update playCount ke Redis
      if (typeof onEndPlay === 'function') {
        onEndPlay(id); // Misalnya parent akan +1 playCount di Redis
      }
    };

    audio.addEventListener('timeupdate', updateTime);
    audio.addEventListener('loadedmetadata', setAudioDuration);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('timeupdate', updateTime);
      audio.removeEventListener('loadedmetadata', setAudioDuration);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [id, onEndPlay]);

  return (
    <div className="p-4 border rounded mb-4">
      <div className="flex items-center gap-2 mb-2">
        <input
          type="range"
          min="0"
          max={duration}
          value={currentTime}
          readOnly
          className="w-full accent-blue-500"
        />
      </div>
      <audio ref={audioRef} src={question} preload="auto" />
      <div className="flex gap-2">
        {isPlaying ? (
          <button
            type="button"
            className="px-4 py-2 bg-yellow-500 text-white rounded"
          >
            Playing ...
          </button>
        ) : (
          <button
            type="button"
            onClick={handlePlay}
            disabled={playCount >= numPlay}
            className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
          >
            Play {playCount >= numPlay ? '(Limit reached)' : ''}
          </button>
        )}
      </div>
    </div>
  );
};

export default AudioQuestion;
